export enum ContractStatusType {
  ACTIVE = '91bf83fc-954b-4b78-a6c3-9cfff0459c59',
  PASSIVE = 'f180adf2-6fce-47da-b531-140e99a451ed',
  DRAFT = '4286bf82-f9fb-41d0-a115-4d82fb405907'
}
